(function () {
  var root = document.documentElement;
  var previewSelector = '.canvas-container';
  var hostSelector = 'media-gallery .product__media-list .product-media-container';
  var mountClass = 'ss-customily-gallery-preview-mount';
  var hostClass = 'ss-customily-preview-host';
  var mountedClass = 'ss-customily-preview-mounted';
  var observer = null;
  var attempts = 0;
  var interval = 0;

  function markReady() {
    if (typeof window.__ssCustomilyPreviewReady === 'function') {
      window.__ssCustomilyPreviewReady();
      return;
    }

    root.classList.remove('ss-customily-preview-pending');
    root.classList.add('ss-customily-preview-ready');
  }

  function visible(element) {
    if (!element) return false;
    var style = window.getComputedStyle(element);
    var rect = element.getBoundingClientRect();
    return style.display !== 'none' &&
      style.visibility !== 'hidden' &&
      Number(style.opacity || 1) > 0.01 &&
      rect.width > 40 &&
      rect.height > 40;
  }

  function hasPreviewSize(element) {
    if (!element) return false;
    var rect = element.getBoundingClientRect();
    if (rect.width > 40 && rect.height > 40) return true;

    return Array.prototype.slice.call(element.querySelectorAll('canvas')).some(function (canvas) {
      var canvasRect = canvas.getBoundingClientRect();
      return canvasRect.width > 40 && canvasRect.height > 40;
    });
  }

  function galleryHost() {
    return document.querySelector(hostSelector);
  }

  function ensureMount(host) {
    if (!host) return null;

    host.classList.add(hostClass);
    var mount = host.querySelector('.' + mountClass);
    if (mount) return mount;

    mount = document.createElement('div');
    mount.className = mountClass;
    mount.setAttribute('aria-hidden', 'true');
    host.appendChild(mount);
    return mount;
  }

  function previewContainer() {
    return Array.prototype.slice.call(document.querySelectorAll(previewSelector)).find(function (element) {
      if (element.closest('media-gallery')) return false;
      if (!element.querySelector('canvas.lower-canvas, canvas.upper-canvas, canvas')) return false;
      return hasPreviewSize(element);
    }) || null;
  }

  function fitPreview(container) {
    if (!container) return;

    container.classList.remove('op-zero');
    container.style.setProperty('display', 'block', 'important');
    container.style.setProperty('opacity', '1', 'important');
    container.style.setProperty('visibility', 'visible', 'important');
    container.style.setProperty('width', '100%', 'important');
    container.style.setProperty('height', '100%', 'important');
    container.style.setProperty('max-width', '100%', 'important');
    container.style.setProperty('max-height', '100%', 'important');

    Array.prototype.slice.call(container.querySelectorAll('canvas')).forEach(function (canvas) {
      canvas.style.setProperty('width', '100%', 'important');
      canvas.style.setProperty('height', '100%', 'important');
      canvas.style.setProperty('max-width', '100%', 'important');
      canvas.style.setProperty('max-height', '100%', 'important');
    });
  }

  function mountedPreviewIsInGallery() {
    var host = galleryHost();
    if (!host) return false;
    var container = host.querySelector('.' + mountClass + ' ' + previewSelector);
    if (!container || !visible(container)) return false;

    var hostRect = host.getBoundingClientRect();
    var previewRect = container.getBoundingClientRect();
    return Math.abs(hostRect.top - previewRect.top) < Math.max(24, hostRect.height * 0.12);
  }

  function mountPreview() {
    var host = galleryHost();
    var preview = previewContainer();
    if (!host || !preview) return false;

    var mount = ensureMount(host);
    if (!mount) return false;

    if (preview.parentElement !== mount) {
      mount.appendChild(preview);
    }

    fitPreview(preview);
    host.classList.add(mountedClass);

    window.requestAnimationFrame(function () {
      window.dispatchEvent(new Event('resize'));
    });

    if (!mountedPreviewIsInGallery()) return false;
    markReady();
    return true;
  }

  function stopWatching() {
    window.clearInterval(interval);
    if (observer) observer.disconnect();
  }

  function watchPreview() {
    if (mountPreview()) {
      stopWatching();
      return;
    }

    observer = new MutationObserver(function () {
      if (mountPreview()) {
        stopWatching();
      }
    });

    observer.observe(document.documentElement, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['class', 'style']
    });

    interval = window.setInterval(function () {
      attempts += 1;
      if (mountPreview() || attempts > 56) {
        stopWatching();
      }
    }, 250);

    window.setTimeout(function () {
      if (mountedPreviewIsInGallery()) {
        markReady();
      } else {
        var host = galleryHost();
        if (host) host.classList.remove(hostClass, mountedClass);
        markReady();
      }
      stopWatching();
    }, 14000);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', watchPreview, { once: true });
  } else {
    watchPreview();
  }
})();
